import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import history from '../utils/history'
import authReducer from './auth/reducer'
import snackbarReducer from './snackbar/reducer'
import loaderReducer from './loader/reducer'
import supplierReducer from './supplier/reducer'
import userReducer from './user/reducer'
import bookableReducer from './bookable/reducer'
import tripReducer from './trip/reducer'
import bookingReducer from './booking/reducer'
import profileReducer from './profile/reducer'
import paymentReducer from './payment/reducer'

const rootReducer = (injectedReducers = {}) => {
  const combinedReducers = combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    snackbar: snackbarReducer,
    loader: loaderReducer,
    supplier: supplierReducer,
    bookable: bookableReducer,
    user: userReducer,
    trip: tripReducer,
    booking: bookingReducer,
    profile: profileReducer,
    payment: paymentReducer,
    ...injectedReducers,
  })

  return (state, action) => {
    return combinedReducers(state, action)
  }
}

export default rootReducer
